# scroll-util.coffee
# Helper methods for scrolling.
$ = require 'jquery'

module.exports =
  scrolledDownPast: (->
    $document = $ document
    lastPosition = $(window).scrollTop() + 20
    return (height, velocity = 7) ->
      currentPosition = $(window).scrollTop()
      pageHeight = $document.height() - window.innerHeight - 100
      if pageHeight < 0 then return false
      hasScrolled = (currentPosition > height and currentPosition > lastPosition + velocity) or currentPosition >= pageHeight
      lastPosition = currentPosition
      return hasScrolled
  )()

  scrolledUpWithVelocity: (->
    $document = $ document
    lastPosition = $(window).scrollTop() + 20
    return (velocity) ->
      currentPosition = $(window).scrollTop()
      hasScrolled = (currentPosition + velocity) < lastPosition
      lastPosition = currentPosition
      return hasScrolled
  )()

  scrolledBelowElement: ($element) ->
    depth = $element.offset()?.top + $element.height() or 200
    return -> $(window).scrollTop() > depth

  elementBelowElement: ($element) ->
    depth = $element.offset()?.top - $element.height() or 200
    return ($otherElement) ->
      $otherElement.offset()?.top < depth

